<template>
<div class="subpage__body">
  <section>
  <h2>Page not found</h2>
  <p>
    Sorry, pick another one in the link tree
  </p>
</section>
</div>
</template>